import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { ArrowUp, ArrowDown, GripVertical, MapPin } from "lucide-react";

export function RoutePreview({ open, list, km, surucu, onClose, onConfirm, setList }) {
  const [drag, setDrag] = useState(null);
  const move = (i, j) => { if (j < 0 || j >= list.length) return; const a = [...list]; const [x] = a.splice(i, 1); a.splice(j, 0, x); setList(a); };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="route-preview" className="max-w-3xl border-slate-700 bg-slate-900 text-slate-100">
        <DialogHeader><DialogTitle>DAĞITIM SIRASI — {surucu}</DialogTitle></DialogHeader>
        <p className="text-[11px] text-slate-400">ŞUBEDEN BAŞLAYIP EN YAKIN ALICIYA GÖRE DİZİLDİ{km ? ` · YAKLAŞIK ${km.toLocaleString("tr-TR")} KM (KUŞ UÇUŞU)` : ""}. KONUMU OLMAYANLAR İLÇE / ADRESE GÖRE SONDA. SÜRÜKLEYEREK VEYA OKLARLA DEĞİŞTİREBİLİRSİNİZ.</p>
        <div className="max-h-[55vh] space-y-1 overflow-auto">
          {list.map((c, i) => (
            <div key={c.id} data-testid={`route-row-${c.id}`} draggable onDragStart={() => setDrag(i)} onDragOver={(e) => e.preventDefault()} onDrop={() => { if (drag !== null) move(drag, i); setDrag(null); }}
              className="flex items-center gap-2 rounded border border-slate-800 bg-slate-950/50 px-2 py-1.5 text-xs">
              <GripVertical className="h-4 w-4 cursor-grab text-slate-500" />
              <span className="w-6 text-center font-extrabold text-sky-300">{i + 1}</span>
              <div className="min-w-0 flex-1">
                <div className="truncate font-bold">{c.data?.alici_firma || c.data?.sevk_firma}</div>
                <div className="truncate text-[10px] text-slate-400">{[c.data?.alici_adres, c.data?.alici_ilce, c.data?.alici_il].filter(Boolean).join(" · ")} · {c.data?.takip_no}</div>
              </div>
              {c._konum ? <MapPin className="h-3.5 w-3.5 text-emerald-400" title="KONUMLU" /> : <span className="text-[10px] text-slate-500">KONUM YOK</span>}
              <button data-testid={`route-up-${c.id}`} onClick={() => move(i, i - 1)} className="rounded p-0.5 hover:bg-slate-800"><ArrowUp className="h-3.5 w-3.5" /></button>
              <button data-testid={`route-down-${c.id}`} onClick={() => move(i, i + 1)} className="rounded p-0.5 hover:bg-slate-800"><ArrowDown className="h-3.5 w-3.5" /></button>
            </div>
          ))}
        </div>
        <div className="flex justify-end gap-2">
          <Button variant="outline" data-testid="route-cancel" onClick={onClose} className="border-slate-700">VAZGEÇ</Button>
          <Button data-testid="route-confirm" onClick={onConfirm} className="bg-sky-600 text-white hover:bg-sky-700">ZİMMETLE + RUT PDF ({list.length})</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
